import './set-public-path';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import VueContentPlaceholders from 'vue-content-placeholders';
import { vfmPlugin } from 'vue-final-modal';
import singleSpaVue from 'single-spa-vue';
import VModal from 'vue-js-modal';
import { VPopover, VTooltip, VClosePopover } from 'v-tooltip';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';
import App from './App.vue';
import store from '@/store';
import router from './router';
import 'vue-js-modal/dist/styles.css';

import('lazysizes');

Vue.component('VPopover', VPopover);
Vue.directive('tooltip', VTooltip);
Vue.directive('closePopover', VClosePopover);
Vue.use(VModal);
Vue.use(vfmPlugin);
Vue.use(VueContentPlaceholders);
Vue.component('AppLink', () => import('./components/AppLink'));
Vue.use(Vuelidate);
Vue.use(VueCompositionAPI);
Vue.use(VueMeta);

Vue.config.productionTip = false;

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    el: '#book24-widget-app-entrypoint',
    render(h) {
      return h(App);
    },
    router,
    store,
  },
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;
